import { gql } from '@apollo/client'

export const DEPOSIT_KREDITS_CORPORATE_FUNDS = gql`
  mutation DepositKreditsCorporateFunds($input: DepositKreditsCorporateFundsInput!) {
    depositKreditsCorporateFunds(input: $input)
  }
`
export const DEPOSIT_KREDITS_BONUS_FUNDS = gql`
  mutation DepositKreditsBonusFunds($input: DepositKreditsBonusFundsInput!) {
    depositKreditsBonusFunds(input: $input)
  }
`
export const DEPOSIT_KREDIT_CORPORATE_FUNDS = gql`
  mutation DepositKreditCorporateFunds($input: DepositKreditCorporateFundsInput!) {
    depositKreditCorporateFunds(input: $input)
  }
`
